import { render, staticRenderFns } from "./SubscriptionUserOrders.vue?vue&type=template&id=379195f5&scoped=true"
import script from "./SubscriptionUserOrders.vue?vue&type=script&lang=js"
export * from "./SubscriptionUserOrders.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionUserOrders.vue?vue&type=style&index=0&id=379195f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379195f5",
  null
  
)

export default component.exports